<template>
  <base-container ref="container" style="height: 100%" :isLoading="loading">
    <base-container ref="container" style="height: 100%">
      <el-row
        type="flex"
        align="middle"
        style="border-bottom: 2px #ebeef5 solid"
        v-for="(schedules, date) in dateSchedules"
        :key="date"
      >
        <el-col :span="4" class="align-center padding7">
          <b>{{ date }}</b>
          <div>{{ getDateWeekLabel(date) }}</div>
        </el-col>
        <el-col :span="18" style="padding: 10px 20px">
          <el-row>
            <el-col
              style="border-bottom: 0.5px #1989fa solid"
              :span="5"
              :offset="1"
              v-for="(period, index) in schedules"
              :key="index"
            >
              <el-row type="flex" align="middle" justify="space-between">
                <span>{{ period.startPoint }}-{{ period.endPoint }}</span>
                <span>
                  {{ period.totalCount }}
                  <el-popover placement="right" trigger="hover">
                    <el-row
                      style="border-bottom: 0.5px #1989fa solid"
                      type="flex"
                      justify="space-between"
                      v-for="rate in period.rates"
                      :key="rate.appId"
                    >
                      <b>{{ rate.appName }}</b>
                      <b>{{ rate.rate }}%</b>
                    </el-row>
                    <i
                      slot="reference"
                      class="el-icon-question color-warning"
                    ></i>
                  </el-popover>
                </span>
              </el-row>
            </el-col>
            <el-col
              style="border-bottom: 0.5px #1989fa solid"
              :span="5"
              :offset="1"
              v-if="schedules.length"
            >
              <el-row type="flex" justify="space-between">
                <b>合计</b>
                <b>{{ summary(schedules) }}</b>
              </el-row>
            </el-col>
          </el-row>

          <div class="align-center" v-if="!schedules.length">
            <b>暂无排班计划</b>
          </div>
        </el-col>
        <el-col :span="2" class="align-center padding7" v-if="isChangable(chedules, date)">
          <el-button
            
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="editSchedule(date)"
            >排班调整</el-button
          >
        </el-col>
      </el-row>
    </base-container>
    <artisan-dialog
      ref="dialog"
      :title="dialog.title"
      :visible.sync="dialog.isShow"
      height="70%"
      width="70%"
      :isLoading="dialog.loading"
    >
      <template #footer>
        <el-button
          size="mini"
          type="danger"
          icon="el-icon-delete"
          @click="dialog.isShow = false"
        >
          取消
        </el-button>
        <el-button size="mini" type="success" icon="el-icon-check">
          确认
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { loadSchedule } from "@/api/jc/schedule";
import moment from "moment";
import { getWeekLabel } from "@/util/util";
export default {
  props: {
    resId: [String, Number],
    start: String,
    end: String,
    apps: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    let date = moment(this.start).toDate();
    return {
      date,
      loading: false,
      list: [],
      dialog: {
        title: "",
        isShow: false,
        loading: false,
      },
    };
  },
  computed: {
    dateSchedules() {
      let arr = {};
      let iDate = moment(this.start);
      while (iDate.format("YYYY-MM-DD") <= this.end) {
        arr[iDate.format("YYYY-MM-DD")] = [];
        iDate = moment(iDate).add(1, "days");
      }
      this.list.forEach((c) => {
        arr[c.scheduleDate].push(c);
      });
      return arr;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    isChangable(chedules, date) {
      return date > moment().format("YYYY-MM-DD");
    },
    loadData() {
      this.loading = true;
      loadSchedule(this.resId, this.start, this.end)
        .then((res) => {
          this.list = res.data.data.sort((o1, o2) => o1.sortNo - o2.sortNo);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDateWeekLabel(date) {
      let weekNo = moment(date).weekday();
      return getWeekLabel(weekNo);
    },
    summary(periods) {
      let sum = 0;
      periods.forEach((c) => {
        sum += c.totalCount;
      });
      return sum;
    },
    editSchedule(date) {
      this.dialog.title = date + "--排班调整";
      this.dialog.isShow = true;
    },
  },
};
</script>

<style scoped>
</style>